/**
 * rejillaIS.js · helper puro de detección IS para la rejilla anual.
 *
 * PR-RejillaIS-1 (Ann 2026-05-26) · regla visual aprobada:
 *
 *   esCobroIS(mes) = true si CUALQUIERA de:
 *     1. mes.tipo === "cuota_is"
 *     2. tramos de incidencia (tramos_calculo con tipo='incidencia')
 *     3. concepto u origen_concepto contienen señales claras de IS:
 *          "[IS"               · marca explícita histórica
 *          "CUOTA IS "         · canónico legacy (case-insensitive)
 *          "INCIDENCIA DE SALUD"
 *     4. "[IS mes completo]" en concepto raíz
 *
 * Cambio respecto a la versión previa: la rama 3 (concepto) ya NO exige
 * `es_mixto === true`. Antes, marzo 2026 de Rosa Maria Serra Galceran tenía
 * origen.concepto='Cuota Marzo-2026 IS Incidencia de Salud' pero es_mixto
 * ausente y no se pintaba IS. Ahora la señal de concepto basta sola.
 *
 * Helper puro · sin side-effects · sin depender de React.
 */

/**
 * @param {object} mes - una fila de la rejilla anual con campos:
 *   tipo, concepto, origen_concepto, tramos_calculo (array de tramos)
 * @returns {boolean} true si la fila debe pintarse con estética IS naranja.
 */
function esCobroIS(mes) {
  if (!mes || typeof mes !== "object") return false;

  // 1 · tipo canónico nuevo
  if (mes.tipo === "cuota_is") return true;

  // 2 · tramos con incidencia
  const tc = Array.isArray(mes.tramos_calculo) ? mes.tramos_calculo : [];
  const tieneTramos = tc.length === 4;
  const tcInc = tc.filter((t) => t && t.tipo === "incidencia");
  if (tieneTramos && tcInc.length > 0) return true;

  // 3 · señales en concepto u origen_concepto (case-insensitive para canónicos)
  const concepto = mes.concepto || "";
  const origenConcepto = mes.origen_concepto || "";
  const conceptoU = concepto.toUpperCase();
  const origenU = origenConcepto.toUpperCase();
  if (concepto.includes("[IS")) return true;
  if (conceptoU.includes("CUOTA IS ")) return true;
  if (conceptoU.includes("INCIDENCIA DE SALUD")) return true;
  if (origenU.includes("CUOTA IS ")) return true;
  if (origenU.includes("INCIDENCIA DE SALUD")) return true;

  // 4 · marca "[IS mes completo]"
  if (concepto.includes("[IS mes completo]")) return true;

  return false;
}

module.exports = { esCobroIS };
